import { render, staticRenderFns } from "./AddReceiptsToReturnBankReturn.vue?vue&type=template&id=c17cb80e"
import script from "./AddReceiptsToReturnBankReturn.vue?vue&type=script&lang=js"
export * from "./AddReceiptsToReturnBankReturn.vue?vue&type=script&lang=js"
import style0 from "./AddReceiptsToReturnBankReturn.vue?vue&type=style&index=0&id=c17cb80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports